import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getConsent } from '_components/atoms/cookie-consent';

const GTM_ID = 'GTM-PPTZXGWJ';

// Marketing pages only — passengers, portal users and authenticated routes are excluded.
const MARKETING_PATHS = [
  '/',
  '/business',
  '/about-us',
  '/contact',
  '/request-demo',
  '/download',
  '/privacy',
  '/cookies',
];

const GTM = ({ consentGiven }) => {
  const { pathname } = useLocation();
  const isMarketingPage = MARKETING_PATHS.includes(pathname);

  // Check consent from prop (live update) or localStorage (page load)
  const hasConsent = consentGiven || getConsent() === 'accepted';

  useEffect(() => {
    if (!isMarketingPage || !hasConsent) return;

    // Initialise dataLayer if it doesn't exist
    window.dataLayer = window.dataLayer || [];

    // Set Google Consent Mode defaults
    if (!window.__gtm_consent_set) {
      window.dataLayer.push({
        event: 'consent_update',
        'gtm.start': new Date().getTime(),
      });

      // Grant analytics consent
      if (window.gtag) {
        window.gtag('consent', 'update', {
          analytics_storage: 'granted',
        });
      }
      window.__gtm_consent_set = true;
    }

    // Load the GTM script once
    if (!window.__gtm_loaded) {
      window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
      document.head.appendChild(script);
      window.__gtm_loaded = true;
    }

    // Push a virtual pageview on every marketing route change (SPA navigation)
    window.dataLayer.push({
      event: 'virtualPageview',
      pagePath: pathname,
      pageTitle: document.title,
    });
  }, [pathname, isMarketingPage, hasConsent]);

  return null;
};

export default GTM;
